import Lottie from "lottie-react";

import loadingAnimation from "../../../assets/loaders/Loading-2.json";

const LoadingTwo = ({
  loop = true,
  autoplay = true,
  style = { width: "100%", height: "100%" },
  strokeWidth = 1
}: {
  loop?: boolean;
  autoplay?: boolean;
  style?: any;
  strokeWidth?: number;
}) => {
  // Function to modify stroke width in the animation data
  const modifyStrokeWidth = (animData: any, factor: number) => {
    const modifiedData = JSON.parse(JSON.stringify(animData)); // Deep clone

    // Traverse layers and modify stroke width
    if (modifiedData.layers) {
      modifiedData.layers.forEach((layer: any) => {
        if (layer.shapes) {
          layer.shapes.forEach((shape: any) => {
            if (shape.it) {
              shape.it.forEach((item: any) => {
                if (item.ty === "st" && item.w) {
                  // 'st' is stroke type, 'w' is width
                  if (typeof item.w.k === "number") {
                    item.w.k = item.w.k * factor;
                  }
                }
              });
            }
          });
        }
      });
    }

    return modifiedData;
  };

  const animationData =
    strokeWidth !== 1
      ? modifyStrokeWidth(loadingAnimation, strokeWidth)
      : loadingAnimation;

  return (
    <Lottie
      animationData={animationData}
      loop={loop}
      autoplay={autoplay}
      style={style}
    />
  );
};

export default LoadingTwo;
